const COMMON_HEADER_PREFIX = "header";

export const COMMON_HEADER_TEST_IDS = {
    BACK_BUTTON: `${COMMON_HEADER_PREFIX}_back`,
    TITLE: `${COMMON_HEADER_PREFIX}_title`,
    SUB_TITLE: `${COMMON_HEADER_PREFIX}_subtitle`,
};
